import React, { forwardRef, Ref } from 'react';
import { SignatureField as SignatureFieldData } from '@dropbox/sign-internal-client';
import { Timestamped } from './timestamped';
import { ImperativeAPI } from '../types/imperative-api';
import { SignatureImage } from './signature-image';

type Props = {
  fieldData: SignatureFieldData;
  showTimestamp?: boolean;
  isFormView?: boolean;
};

function SignatureFieldInternal(
  { fieldData, showTimestamp, isFormView }: Props,
  ref: Ref<ImperativeAPI>,
) {
  if (fieldData.signature != null) {
    const img = (
      <SignatureImage
        isFormView={isFormView}
        signer={fieldData.signer}
        signatureGuid={fieldData.signature.guid}
        ref={ref}
      />
    );

    if (showTimestamp && fieldData.signerName) {
      return (
        <Timestamped fieldHeight={fieldData.height} name={fieldData.signerName}>
          {img}
        </Timestamped>
      );
    }

    return img;
  }

  return null;
}

export const SignatureField = forwardRef(SignatureFieldInternal);
